module.exports = __webpack_public_path__ + "static/media/greenParrot.a02f5615.png";